<script lang='ts' setup>
import { useRoute } from 'vue-router'
const route = useRoute()
definePageMeta({
  title: '404',
  layout: false
})
if (route.path === '/') {
  navigateTo('/home')
}
</script>

<template>
  <div>404：页面找不到啦</div>
</template>

<style lang='scss' scoped></style>
